export default __webpack_public_path__ + "static/AcidGrotesk-Regular-c80e80ee3ff05a2e778337a3e1470efb.woff2";